import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { AddRowButtonProps } from './AddRowButton.props';

const AddRowButton = ({ addRow, tableTerms, disabled }: AddRowButtonProps) => (
  <Button size="small" variant="outlined" color="primary" startIcon={<AddIcon />} onClick={addRow} disabled={disabled}>
    Add {tableTerms.columnName}
  </Button>
);

export default AddRowButton;
